export function getCalculatedStepPLEL(step: number) {
  switch (true) {
    case step === 4:
      return 1
    case step >= 7 && step <= 12:
      return 2
    case step === 13:
      return 3
    case step === 14:
      return 4
    case step >= 15 && step <= 17:
      return 5
    case step >= 26 && step <= 29:
      return 6
    default:
      return 0
  }
}
export function getCalculatedStepPC(step: number) {
  switch (true) {
    case step >= 7 && step <= 12:
      return 1
    case step === 13:
      return 2
    case step === 14:
      return 3
    case step >= 18 && step <= 24:
      return 4
    case step === 25:
      return 5
    case step >= 26 && step <= 29:
      return 6
    default:
      return 0
  }
}
export function getCalculatedStepCC(step: number) {
  switch (true) {
    case step >= 7 && step <= 12:
      return 1
    case step === 13:
      return 2
    case step === 14:
      return 3
    case step >= 15 && step <= 17:
      return 4
    case step >= 18 && step <= 24:
      return 5
    case step === 25:
      return 6
    case step >= 26 && step <= 29:
      return 7
    default:
      return 0
  }
}

export type SelectedCoverType = 'PLEL' | 'PC' | 'CC'

export function getCalculatedStepByCoverType(
  coverType: SelectedCoverType | undefined,
  step: number
) {
  if (coverType === undefined) return 0
  switch (coverType) {
    case 'PLEL':
      return getCalculatedStepPLEL(step)
    case 'PC':
      return getCalculatedStepPC(step)
    case 'CC':
      return getCalculatedStepCC(step)
  }
}
